// Confirm matching field values
export default (form) => {
    const checkFieldsMatch = (field) => {
        const valueToMatch = form.querySelector(`input[name="${field.dataset.fieldtomatch}"]`).value;
        field.setCustomValidity(field.value !== valueToMatch ? 'Inputs do not match' : '');
    };

    const confirmationFields = Array.from(form.querySelectorAll('.js-check-match'));

    confirmationFields.forEach((field) => {
        const coupledField = form.querySelector(`input[name="${field.dataset.fieldtomatch}"]`);
        checkFieldsMatch(field);
        field.addEventListener('change', () => checkFieldsMatch(field));
        coupledField.addEventListener('change', () => checkFieldsMatch(field));
    });
};
